import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { LeadNode } from '@generated/graphql';

@Component({
  selector: 'my-leads-block',
  templateUrl: './my-leads-block.component.html',
  styleUrls: ['./my-leads-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyLeadsBlockComponent {
  @Input() leads?: LeadNode[];
  @Output() rowClick: EventEmitter<any> = new EventEmitter();
  @Output() assignLead = new EventEmitter<LeadNode>();
}
